import { FormikProps } from 'formik';
import { KeyedMutator } from 'swr';

export interface IReason {
  id: string;
  numericId: number;
  label: string;
  description: string;
  lenderId?: string[];
  lenderIds: string[];
  lenderList: Array<ILenderData>;
  stipTypeId?: string;
}

export enum StepTypeEnum {
  Step = 'Step',
  Fork = 'Fork',
  ReRoute = 'ReRoute',
  ReRouteAll = 'ReRouteAll',
}

export type TStep = keyof typeof StepTypeEnum;

export interface IReRouteDetails {
  workflowId: string;
  workflowName: string;
  workflowStepId: string;
  stepName: string;
}

export interface IWorkflowStep {
  id: string;
  numericId: number;
  workflowId: string | null;
  displayName: string;
  name: string;
  isStartStep: boolean;
  description: string;
  orderNumber: number;
  stepType: TStep;
  minutesGreen: number;
  minutesAmber: number;
  minutesRed: number;
  isDefault: boolean;
  trackerStageId: number;
  trackerStepId: number;
  textCommentColor: string;
  isTextBold: boolean;
  parentWorkflowStepId: string | null;
  reRouteWorkflowStepId: string | null;
  reRouteDetails: IReRouteDetails;
  roleIds: string[];
  roleIdsCanUndo: string[];
  reasons: IReason[];
  childSteps: IWorkflowStep[];
  stepPath: string;
}

export interface IWorkflow {
  workflowId: string;
  workflowName: string;
  entityType: string;
  workflowSteps: IWorkflowStep[];
}

export type TWorkflowModalProps = {
  handleClose: () => void;
  handleSubmit: (data: TWorkflowFormState) => void;
  isEditMode: boolean;
  workflowModalPosition: number;
  currentWorkflow: IWorkflow | null;
};

export type EnitityType = 'Lead' | 'Deal';

export type TWorkflowFormState = {
  name: string;
  entityType: EnitityType;
};

export interface IWorkflowFormProps extends Partial<FormikProps<TWorkflowFormState>> {
  handleClose: () => void;
  isEditMode: boolean;
}

export interface IParentStepModalProps<T> {
  handleClose: () => void;
  handleSubmit: (data: T) => void;
  currentStep: IWorkflowStep | null;
  selectedWorkflow: IWorkflow | null;
  parentStepModalPosition: number;
}

export type TParentStepFormState = {
  parentWorkflowStepId: string | null;
  id: string | null;
};

export interface IParentStepModalFormProps {
  handleClose: () => void;
  currentStep: IWorkflowStep | null;
  setFieldValue: (fieldName: string, fieldValue: string) => void;
  selectedWorkflow: IWorkflow | null;
}

export type TStepProps = {
  stepData: IWorkflowStep;
  handleOnStepClick: (id: string) => void;
  isChecked: boolean;
  handleEditStep: (data: IWorkflowStep) => void;
  handleAddStep: (id: string) => void;
  handleEditParentStep: (id: string | null, parentStepId: string | null) => void;
};

export type TCollapseItemProps = {
  stepData: IWorkflowStep;
  handleChangeCheckbox: (step: IWorkflowStep | null) => void;
  selectedStep: IWorkflowStep | null;
  defaultSelectedStep?: string;
};

export interface IStepFormProps<T> extends Partial<FormikProps<T>> {
  handleClose: () => void;
  isEditMode: boolean;
  stepData: IWorkflowStep | null;
  refreshWorflow: KeyedMutator<IWorkflow[]>;
  workflows: IWorkflow[];
  workflowLevel: boolean;
}

export type TTRKRData = {
  id: number;
  title: string;
};

export type TStepModalProps = {
  handleClose: () => void;
  handleSubmit: (data: IWorkflowStep) => void;
  isEditMode: boolean;
  stepData: IWorkflowStep | null;
  tStepModalPositon: number;
  refreshWorflow: KeyedMutator<IWorkflow[]>;
  workflows: IWorkflow[];
  workflowLevel: boolean;
};

export type TStepModalFormState = {
  workflowId: string | null;
  displayName: string;
  name: string;
  description: string;
  orderNumber: number;
  stepType: TStep;
  minutesAmber: number;
  minutesGreen: number;
  minutesRed: number;
  isDefault: boolean;
  trackerStageId: number;
  trackerStepId: number;
  textCommentColor: string;
  isTextBold: boolean;
  parentWorkflowStepId: string | null;
  reRouteWorkflowStepId: string | null;
  roleIds: string[];
  roleIdsCanUndo: string[];
  reasons: IReason[];
  stepPath: string;
};

export interface ILender {
	id: string;
	name: string;
  code: string;
  numericId: number;
  rank: number;
  subRank: number;
  acumaticaId: string;
}

export interface ICreateReasonRequest {
	workflowStepId?: string | null,
  label: string,
  description: string,
  autoSelectLenders: string[],
  numericId?: number,
  stipTypeId?: string,
}

export interface ILenderData {
  id: string,
  lenderName: string,
}

export interface IStepListProps {
  workflows: IWorkflow[];
  handleChangeDestStep: (step: IWorkflowStep | null) => void;
  stepData?: IWorkflowStep | null;
}